import { render, staticRenderFns } from "./TablaMisVisitas.vue?vue&type=template&id=0ef75590&"
import script from "./TablaMisVisitas.vue?vue&type=script&lang=ts&"
export * from "./TablaMisVisitas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports